import api from '@anm/api';
import useDownloadCsv from '@anm/hooks/useDownloadCsv';

const downloadWebinarComments = async (streamId: string) => {
  const fetchedData = await api().stream.getWebinarComments(streamId);

  useDownloadCsv({ data: fetchedData, fileName: `${streamId}_comments.csv` })();
};

export default downloadWebinarComments;
